import PageHead from "@/components/header/PageHead";
import SetOperator from '@/components/operator/SetOperator';
export default {
  name: "OperatorPage",
  components: {
    PageHead,
    SetOperator
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch('initCurrentNodeData', {
        nodeId: this.$route.params.provider
      });
    }
  },
  computed: {
    docsUrlPrefix() {
      return `https://docs.stfil.io/${this.$i18n.locale === "zh" ? 'v/cn/' : ''}`;
    }
  }
};